/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "antd"
import { typeConvert } from "./BodyParams"

const QueryParams = ({ queryParams, setData, values }: { queryParams: any, setData: any, values: any }) => {
  return <div className="">
    <div className="font-semibold mb-1 text-[14px]">
      Query Params
    </div>
    <div className="border bg-[#fafafa] p-3 rounded ">
      {
        queryParams?.map((param, index) => {
          return <div className="flex justify-between mb-3 gap-3" key={index}>
            <div className="">
              <div className="flex justify-between">
                <div className="flex gap-[10px] items-center text-[16px]">
                  <span className="font-semibold max-w-[140px]  2xl:max-w-[400px] text-ellipsis overflow-hidden" title={param.name}>{param.name}</span>
                  <span className="text-[#B8BABD]">{param?.type}</span>
                  <span className="text-[#dd1e2e]">{param.required ? 'required' : ''}</span>
                </div>
              </div>
              <div>
                <div className="text-[14px] text-[#777A80] 2xl:max-w-[400px] max-w-[250px]">
                  {
                    param.description
                  }
                </div>
              </div>
            </div>

            <div>
              <Input
                type={param?.type === 'boolean' ? 'checkbox' : 'text'}
                value={values?.[param.name] || ''}
                onChange={(e) => {
                  if (param.type === 'boolean') {
                    setData('query', {
                      [param.name]: e.target.checked
                    })
                    return
                  }
                  setData('query', {
                    [param.name]: typeConvert(param.type, e.target.value)
                  })
                }} />
            </div>
          </div>
        })
      }
    </div>
  </div>
}

export default QueryParams